export default __webpack_public_path__ + "static/media/ic_bch_40.fccd1d97.svg";